var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceReservationcomponent = function SvgWorkspaceReservationcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.5h3v-3H5v3Zm3 6H5v-3h3v3Zm0 6H5v-3h3v3Zm24-6H11v-3h21v3Zm-21 6h21v-3H11v3Zm0-12v-3h21v3H11Z",
    fill: "current"
  })));
};
export default SvgWorkspaceReservationcomponent;